/**
 * api.js — Anthropic AI helper.
 * In development + production: calls the Express proxy at /api/claude
 * so the API key is never exposed in the browser.
 */

export async function ai(prompt, system = "", webSearch = false, maxTokens = 2000) {
  const res = await fetch("/api/claude", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ prompt, system, webSearch, maxTokens }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: "Unknown server error" }));
    throw new Error(err.error || `Server error ${res.status}`);
  }

  const data = await res.json();
  if (data.error) throw new Error(data.error);
  return data.text;
}

// Multi-turn chat — messages is [{role:"user"|"assistant", content:"..."}]
export async function aiChat(messages, system = "", maxTokens = 1000) {
  const res = await fetch("/api/claude", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ messages, system, maxTokens }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: "Unknown server error" }));
    throw new Error(err.error || `Server error ${res.status}`);
  }

  const data = await res.json();
  if (data.error) throw new Error(data.error);
  return data.text;
}
